<template>
  <my-view :LoginByUsername="LoginByUsername" :GetLoginVerCode="GetLoginVerCode" :LoginByMobile="LoginByMobile" :GetWxWebSiteQrInfo="GetWxWebSiteQrInfo"></my-view>
</template>

<script>
import {
  LoginByUsername,
  GetLoginVerCode,
  LoginByMobile,
  GetWxWebSiteQrInfo,
} from "@/pages/page1/api/modules/login";

import MyView from "@/pages/publicView/login/login_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      LoginByUsername,
      GetLoginVerCode,
      LoginByMobile,
      GetWxWebSiteQrInfo,
    };
  },
};
</script>